<div class="bread-crumb" >
  <mat-chip-list>
    <mat-chip *ngFor="let route of currentRouteList; last as isLast">
      <a    *ngIf="!isLast" (click)="navigateTo(currentRoute.slice(0, currentRoute.indexOf(route) + route.length));">{{route}}</a>
      <span *ngIf="isLast">{{route}}</span>
    </mat-chip>
  </mat-chip-list>
</div>
